import { useState } from 'react';

const useThrottledAsync = (fn, delay = 3000) => {
  const [loading, setLoading] = useState(false);

  const wrapped = async (...args) => {
    if (loading) return;
    setLoading(true);
    try {
      await fn(...args);
    } finally {
      setTimeout(() => setLoading(false), delay);
    }
  };

  return [wrapped, loading];
};

export { useThrottledAsync };
